import * as styles from './styles.css';
import { Wrapper } from 'shared/components/Wrapper';
import { Block } from 'shared/components/Block';
import { Title } from 'shared/components/Title';
import { Description } from 'shared/components/Description';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';
import { LeadGenerationUtp } from '../LeadGenerationUtp/LeadGenerationUtp';
import { UTP, WHITE_UTP } from './constants';
import { SubTitle } from 'shared/components/SubTitle';

export const LeadGenerationBuilders: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.LeadGeneration}>
          <Block>
            <Title text="Лидогенерация для застройщиков" />
            <Description
              text={[
                {
                  value:
                    'Лидогенерация — это модель, при которой застройщики оплачивают только целевые обращения (лиды) от покупателей. Клиенты оплачивают звонки, сообщения в чате или заявки, а не показы. ',
                },
              ]}
            />
            <Description
              text={[{ value: 'Модель оплаты:', isBold: true }, { value: ' Cost Per Lead (CPL) — оплата за лид' }]}
            />
          </Block>
        </Element>
        <Block withoutMarginBottom>
          <SubTitle text="Откуда приходят лиды" />
          <LeadGenerationUtp utp={UTP} />
        </Block>
        <Block>
          <Description
            text={[
              { value: 'Что считается платным звонком:', isBold: true },
              {
                value: ' первый звонок пользователя по ЖК в месяц, длительностью от 30 секунд, не повторный, не спам.',
              },
            ]}
          />
          <Description
            text={[
              { value: 'Тарифы:', isBold: true },
              { value: ' 4 уровня с разной стоимостью лида, кешбэком и доступом к инструментам продвижения.' },
            ]}
          />
          <Description
            text={[
              {
                value:
                  'Итоговая позиция объявлений зависит от стоимости звонка, состоящей из уровня тарифа и ставки, которую выбрал застройщик, и из персонализации, которая показывает объвления аудитории, для которой они наиболее релевантны.',
              },
            ]}
          />
        </Block>
        <Block withoutMarginBottom>
          <SubTitle text="Преимущества CPL-модели для застройщиков" />
          <LeadGenerationUtp utp={WHITE_UTP} whiteTheme />
        </Block>
      </Wrapper>
    </div>
  );
};
